module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill=\"#ffffff\" d=\"M18 12.998H6a1 1 0 0 1 0-2h12a1 1 0 0 1 0 2\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/minus.svg
// module id = mPcm
// module chunks = 1